<template>
  <DashboardPanel
    :hydrated="hydrated || null"
    :refreshParams="{entityId}"
    @refreshed="hydrate"
    @removed="emit('removed')"
  >
    <ContactDetails
      :addressCountry="addressCountry"
      :addressLine1="addressLine1"
      :addressLine2="addressLine2"
      :addressLine3="addressLine3"
      :addressPostcode="addressPostcode"
      :addressTown="addressTown"
      :businessName="businessName"
      :contactName="contactName"
      :telephone="telephone"
    />

    <dl>
      <dt>Allow Consolidation</dt>
      <dd>
        <tick-or-cross :tick="consolidate" />
      </dd>
    </dl>

  </DashboardPanel>
</template>

<script setup>
import { ref } from "vue";
import DashboardPanel from "@root/components/DashboardPanel.vue";
import useHydration from "@root/hooks/useHydration";
import TickOrCross from "@root/components/TickOrCross.vue";
import ContactDetails from "@root/components/ContactDetails.vue";

const props = defineProps({
  entityId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['removed']);

const addressCountry = ref('');
const addressLine1 = ref('');
const addressLine2 = ref('');
const addressLine3 = ref('');
const addressPostcode = ref('');
const addressTown = ref('');
const businessName = ref('');
const contactName = ref('');
const telephone = ref('');
const consolidate = ref(false);

const { hydrate, hydrated } = useHydration(({
                                              address_country: _addressCountry,
                                              address_line_1: _addressLine1,
                                              address_line_2: _addressLine2,
                                              address_line_3: _addressLine3,
                                              address_postcode: _addressPostcode,
                                              address_town: _addressTown,
                                              business_name: _businessName,
                                              contact_name: _contactName,
                                              telephone: _telephone,
                                              consolidation: _consolidate,
                                            }) => {
  addressCountry.value = _addressCountry;
  addressLine1.value = _addressLine1;
  addressLine2.value = _addressLine2;
  addressLine3.value = _addressLine3;
  addressPostcode.value = _addressPostcode;
  addressTown.value = _addressTown;
  businessName.value = _businessName;
  contactName.value = _contactName;
  telephone.value = _telephone;
  consolidate.value = _consolidate;
});

</script>
